import { Link, Navigate, useParams } from "react-router-dom";
import { PageHero } from "@/components/site/PageHero";
import { Eyebrow } from "@/components/site/Motion";
import { CTABand } from "@/components/site/CTABand";
import { Pillars } from "@/components/site/Pillars";
import { KrimzonPromise } from "@/components/site/Promise";
import { DigitalByDesign } from "@/components/site/DigitalByDesign";
import { Approach, Offerings, Statement } from "@/components/solution/Sections";
import { SERVICES, getService } from "@/data/services";

const RENDER = { approach: Approach, offerings: Offerings, statement: Statement, digital: DigitalByDesign, principles: Pillars, promise: KrimzonPromise };

const HeroIntro = ({ lead, paras = [] }) => (
  <div className="space-y-4">
    {lead && <p className="font-display text-xl font-semibold text-[#0D9488] md:text-2xl">{lead}</p>}
    {paras.map((p) => (
      <p key={p}>{p}</p>
    ))}
  </div>
);

export default function ServiceDetail() {
  const { slug } = useParams();
  const s = getService(slug);
  if (!s) return <Navigate to="/services" replace />;
  const others = SERVICES.filter((o) => o.slug !== slug);

  return (
    <main data-testid={`service-page-${s.slug}`}>
      <PageHero key={s.slug} eyebrow={`${s.verb} · ${s.title}`} lines={[s.headline]} intro={<HeroIntro lead={s.lead} paras={s.intro} />} image={s.image} testId="service-hero" />
      {s.sections.map(({ type, ...props }, i) => {
        const Section = RENDER[type];
        return <Section key={`${s.slug}-${i}`} {...props} />;
      })}
      <CTABand eyebrow={s.cta.eyebrow} title={s.cta.title} text={s.cta.text} cta={s.cta.button} to={`/contact?service=${encodeURIComponent(s.title)}`} />
      <section className="border-t border-[#E2ECEB] bg-[#F4F9F8]">
        <div className="mx-auto max-w-[1400px] px-6 py-16 lg:px-12">
          <Eyebrow>Other solutions</Eyebrow>
          <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {others.map((o) => (
              <Link key={o.slug} to={`/services/${o.slug}`} data-testid={`other-service-${o.slug}`} className="group border border-[#E2ECEB] bg-white p-6 transition-colors duration-300 hover:border-[#D4AF37]">
                <span className="font-display text-xs font-bold tracking-[0.3em] text-[#0D9488]">{o.verb}</span>
                <span className="font-display mt-2 block font-semibold text-[#0D9488]">{o.title} <span className="text-[#D4AF37]">→</span></span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
